import React, { useState, useEffect, Suspense } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import axios from "axios";

import MPage from "../templates/mpage";
import Cargando from "../components/cargando";
import ErrorMensaje from "../components/errormensaje";
import useObtenerMunicipio from "../../utils/useObtenerMunicipio";
import useTituloPagina from "../../utils/useTituloPagina";

//El visor de PDF arrastra react-pdf/pdfjs (~pesado). Se carga con lazy para
//que quede en un chunk aparte y no infle el bundle del resto de la app
//(en especial el flujo de votación en celular).
const VisorPdf = React.lazy(() => import("../components/visorpdf"));

const Info = (props) => {
  const [municipio, error] = useObtenerMunicipio(props.match.params.munUrl);
  //Preguntas y respuestas del municipio. Antes se importaba el JSON completo
  //(~521KB) dentro del bundle; ahora se piden al backend solo las de este
  //municipio al abrir la página. undefined = cargando; luego es un array
  //(vacío si el municipio no tiene preguntas cargadas).
  const [pregResp, guardarPregResp] = useState(undefined);
  useTituloPagina(municipio ? `Más información — ${municipio.nombre}` : null);

  useEffect(() => {
    if (municipio !== undefined) {
      axios
        .get(`/api/faq/${municipio.nombreUrl}`)
        .then((res) => guardarPregResp(res.data.preguntas))
        //Si falla la carga se trata como "sin preguntas" para no romper la
        //página; queda disponible el resto (bases y condiciones, anexos).
        .catch(() => guardarPregResp([]));
    }
    return () => {
      guardarPregResp(undefined);
    };
  }, [municipio]);

  if (error === true)
    return (
      <ErrorMensaje
        titulo="No encontramos este municipio"
        mensaje="Puede que el enlace esté mal escrito o que el municipio no esté disponible."
      />
    );
  if (municipio === undefined) return <Cargando />;

  const cargandoPreguntas = pregResp === undefined;
  const tienePreguntas = Array.isArray(pregResp) && pregResp.length > 0;

  return (
    <MPage municipio={municipio}>
      <h1 className="centrado font-weight-light mt-4 mb-2 h2">
        Sobre Nuestro Presupuesto Participativo
      </h1>

      {/* Mientras se cargan las preguntas se muestra un aviso; luego, si el
          municipio tiene preguntas y respuestas se muestran, y si no, el PDF
          de bases y condiciones cargado en el municipio. */}
      {cargandoPreguntas ? (
        <p className="centrado text-muted my-4">Cargando información...</p>
      ) : tienePreguntas ? (
        pregResp.map((info, index) => (
          <div className="card m-3" key={index}>
            <div className="card-header">{info.titulo}</div>
            <div className="card-body">
              {info.texto.map((parrafo, index) => (
                <p className="card-text" key={index}>
                  {parrafo}
                </p>
              ))}
            </div>
          </div>
        ))
      ) : (
        municipio.basesCondiciones && (
          <div className="card m-3">
            <div className="card-header">Bases y Condiciones</div>
            <div className="card-body">
              <p className="card-text">
                Consultá las bases y condiciones del Presupuesto Participativo.
              </p>
              <a
                className="btn ppr-btn-verde font-weight-bold"
                href={`/docs/${municipio.basesCondiciones}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver bases y condiciones (PDF)
              </a>
              {/* Vista embebida del PDF (todas las páginas), también en
                  celular. Se renderiza con PDF.js; si por algún motivo no se
                  puede, el botón de arriba abre el archivo aparte. */}
              <Suspense fallback={<p className="text-muted mt-3">Cargando documento…</p>}>
                <VisorPdf file={`/docs/${municipio.basesCondiciones}`} />
              </Suspense>
            </div>
          </div>
        )
      )}

      <div className="card m-3">
        <div className="card-header">Anexos</div>
        {municipio.docs.map((doc) => (
          <a
            className="ppr-a m-3"
            key={doc}
            href={`/docs/${doc}`}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            {doc}
          </a>
        ))}
      </div>

      <div className="text-center mb-3">
        <Link
          to={"/municipio/" + municipio.nombreUrl}
          className="btn ppr-btn-verde font-weight-bold m-2"
        >
          Volver
        </Link>
      </div>
    </MPage>
  );
};

export default withRouter(Info);
